export default __webpack_public_path__ + "static/media/blast-off.6650c2c2.gif";